import "../styles/KickOff.css";
import { MdCheckCircle, MdBolt } from "react-icons/md";

export default function RestartMethod() {
    return (
        <main className="kick">
            <section className="kick-hero">
                <div className="container">
                    <span className="kick-pill">
                        <MdBolt aria-hidden /> Restart
                    </span>

                    <h1 className="kick-title">Restart Method</h1>

                    <p className="kick-desc">
                        Restart Method Il percorso per ripartire da zero, ritrovare energia,
                        equilibrio e benessere autentico. Un programma scientifico e personalizzato
                        che integra nutrizione, movimento e gestione dello stile di vita. <br className="br-lg" />
                        Il primo passo per costruire la tua strategia di successo.
                    </p>
                </div>
            </section>

            {/* BODY */}
            <section className="kick-body">
                <div className="container">
                    <h2 className="kick-subtitle">Per partire con il tuo percorso,effettueremo:</h2>

                    <ul className="kick-list" aria-label="Pilastri del Restart Method">
                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Nutrizione personalizzata</strong> Piano su misura per obiettivi, preferenze e
                                stile di vita, con educazione alimentare pratica.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Movimento mirato</strong> Attività fisica calibrata sul tuo livello attuale,
                                progressioni sostenibili e focus su performance e salute.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Gestione di stress e sonno</strong> Strategie quotidiane per migliorare qualità del
                                riposo, recupero e benessere mentale.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Recupero e benessere</strong> Abitudini efficaci per ridurre fatica, ottimizzare
                                energia e sostenere l’equilibrio ormonale.
                            </div>
                        </li>

                        <li>
                            <MdCheckCircle className="ico" aria-hidden />
                            <div>
                                <strong>Abitudini sostenibili</strong> Metodo step-by-step per consolidare risultati
                                nel tempo e prevenire ricadute.
                            </div>
                        </li>
                    </ul>

                    {/* testo finale come richiesto */}
                    <p className="kick-outro">
                        Restart Method è il percorso pensato per chi desidera ripartire, rimettersi in forma e
                        prendersi cura della propria salute a 360°. Un programma integrato che unisce nutrizione
                        personalizzata, attività fisica mirata, gestione dello stress e strategie per il recupero,
                        con l’obiettivo di ristabilire equilibrio, energia e benessere duraturo.
                    </p>
                    <p className="kick-outro">
                        Grazie a un approccio scientifico e personalizzato, Restart Method non si limita a
                        modificare l’alimentazione: accompagna ogni persona nella costruzione di abitudini
                        sostenibili, nel miglioramento della composizione corporea e nella promozione di uno
                        stile di vita sano e completo.
                    </p>
                    <p className="kick-outro">
                        Che tu voglia ritrovare vitalità, ottimizzare la performance fisica o semplicemente
                        sentirti meglio con te stesso, Restart Method è il punto di partenza per una nuova
                        versione di te, più energica, equilibrata e consapevole.
                    </p>

                    <a href="/contacts" className="btn-ghost">
                        Inizia il tuo Restart <span className="arrow">→</span>
                    </a>
                </div>
            </section>
        </main>
    );
}